import { useAuth0 } from '../auth0-wrapper'

const check = (user, permission) => user.permissions.indexOf(permission) > -1

const Can = props => {
  const { user } = useAuth0()

  return check(user, props.permission) ? props.yes() : props.no()
}

Can.defaultProps = {
  yes: () => null,
  no: () => null,
}

export default Can
